import { createContext } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type JSONObject = Record<string, any>;
type FMSValue = string | JSONObject;

export interface Translations {
  [lang: string]: Record<string, FMSValue>;
}
export interface ContextState {
  language: string;
  translations: Translations;
  changeLanguage(newLanguage: string): void;
  getText(key: string, onMissingKey?: () => string): string;
  getJSON<T>(key: string): T;
  textsLoading: boolean;
}

export const TranslationContext = createContext<ContextState>(null);

export default TranslationContext;
